import React, { Component } from 'react';
import { Grid } from '@mui/material';
import Validation from './Validation';
import TaskInfo from './TaskInfo';
import { send_request } from '../../utils/Request';
import SequentialFormContainer from './SequentialFormContainer';

class SequentialFormTarget extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    if (
      SequentialFormContainer.email &&
      Array.isArray(SequentialFormContainer.email) &&
      SequentialFormContainer.email.length > 0
    ) {
      //email has been initalised
      //do nothing
      //_callback();
      return Promise.resolve();
    } else {
      //fallback
      return send_request('/form_builder/form', '', { form_id: this.props.formId }, 'get')
        .then(res => {
          SequentialFormContainer.credentialId = res.data.data.credentialId;
        })
        .catch(err => {
          this.setState({ loading: false });
          SequentialFormContainer.disableButtonsWhileLoading = false;
        });
    }
  }

  render() {
    const {
      coverImage,
      coverImageCrop,
      linkedComponent,
      redirectToExternalUrl,
      redirectUrl,
      launchSettingDialog,
      uploadIcon,
      formTitle,
      setInnerPlaceholders,
      formId,
    } = this.props;

    return (
      <div>
        <Grid container item xs={12} direction={'column'}>
          {!this.props.isFormSection && (
            <TaskInfo SelectedPlaceholder={this.props.SelectedPlaceholder} />
          )}
          <Validation
            coverImage={coverImage}
            coverImageCrop={coverImageCrop}
            linkedComponent={linkedComponent}
            redirectToExternalUrl={redirectToExternalUrl}
            redirectUrl={redirectUrl}
            launchSettingDialog={launchSettingDialog}
            uploadIcon={uploadIcon}
            formTitle={formTitle}
            setInnerPlaceholders={setInnerPlaceholders}
            formId={formId}
          />
        </Grid>
      </div>
    );
  }
}

export default SequentialFormTarget;
